import { render, staticRenderFns } from "./ContentRenderer.vue?vue&type=template&id=54fa3ec2&scoped=true"
import script from "./ContentRenderer.vue?vue&type=script&lang=js"
export * from "./ContentRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fa3ec2",
  null
  
)

export default component.exports